import { useMemo } from 'react';

import { useHideEmployeeCommissions } from 'hooks';
import { EventDashboard } from 'components/event-dashboard';

import { DashboardProps } from './types';
import { getInitialDateRange } from './helpers';

export const Dashboard = ({ id, event }: DashboardProps) => {
  const hideEmployeeCommissions = useHideEmployeeCommissions();
  const initialDateRange = useMemo(() => getInitialDateRange(event), [event]);

  return (
    <EventDashboard
      id={id}
      withoutPadding
      withDateRangeRestriction
      initDateRange={initialDateRange}
      datePickerContainerPadding="0 0 16px"
      hideEmployeeCommissions={hideEmployeeCommissions}
    />
  );
};
